import { QuestionTestStateSchema } from "@/types/redux-schema";
import { Textarea } from "@mantine/core";
import { useState } from "react";

export default function QuestionTextArea({
  opened,
  questionPartMarks,
  handleAnswerInteraction,
  questionTestState,
  partId,
}: {
  opened: boolean;
  questionPartMarks: number;
  handleAnswerInteraction?: (answer: string, partId?: string) => void;
  questionTestState?: QuestionTestStateSchema;
  partId: string;
}) {
  const [textValue, setTextValue] = useState(
    questionTestState?.textAnswers?.[partId] || ""
  );

  function handleTextChange(event: React.ChangeEvent<HTMLTextAreaElement>) {
    const newValue = event.target.value;
    setTextValue(newValue);
    handleAnswerInteraction?.(newValue, partId);
  }

  return (
    <Textarea
      className="questionTextInputArea"
      autosize
      disabled={opened}
      my={"md"}
      placeholder={opened ? undefined : "Type your answer here"}
      minRows={questionPartMarks}
      maxRows={questionPartMarks * 1.75}
      style={{ gridColumn: "1/-1" }}
      value={textValue}
      onChange={handleTextChange}
    />
  );
}
